import { useTranslation } from "@fanfanlo";
import { Box, Button } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";

export function MarketsDevSettingsOpenLinkButton(){
    const router = useRouter();
    const {t} = useTranslation('homepage/components/page/markets-dev-settings/open-link-button/content');
    async function onClick(){
        const bl = await router.push("/markets-dev-settings");
    }
    return(
        <>
        <Button onClick={onClick}>{t("content.name")}</Button>
        </>
    )
}

export function MarketsDevSettingsLineOpenLinkButton(){
    return(
        <>
            <Box sx={{mt:2, mb:2}}>
                <MarketsDevSettingsOpenLinkButton />
            </Box>
        </>
    )
}